import AuthN from '../../../AuthN.js';
import getAuth0Config from '../utils/getSeekJobsConfig.js';
var auth0Strategy = function (authClient) { return ({
    get: function (ignoreCache) {
        return authClient.isAuthenticated().then(function (isAuthenticated) {
            if (isAuthenticated) {
                return authClient
                    .getToken({ ignoreCache: ignoreCache })
                    .then(function (token) {
                    if (!token) {
                        return {
                            authenticated: false,
                        };
                    }
                    return authClient
                        .getIdentity()
                        .then(function (identity) { return ({
                        token: "Bearer ".concat(token),
                        tokenHeader: 'Authorization',
                        authenticated: isAuthenticated,
                        identity: identity,
                    }); })
                        .catch(function (err) {
                        console.error(err);
                        return {
                            authenticated: false,
                        };
                    });
                })
                    .catch(function (err) {
                    console.error(err);
                    return {
                        authenticated: false,
                    };
                });
            }
            return {
                authenticated: false,
            };
        });
    },
    clear: function () {
    },
}); };
export var createAuth0Strategy = function (_a) {
    var hostOverride = _a.hostOverride;
    return auth0Strategy(new AuthN(getAuth0Config(hostOverride || window.location.host)));
};
export default auth0Strategy;
//# sourceMappingURL=auth0-strategy.js.map